import type { Infer } from 'superstruct';
import { assign, object, optional, string } from 'superstruct';

import { IdObject } from '@adflow/shared/util-superstruct';

export const HistoryGMBLocationDto = assign(
	IdObject,
	object({
		name: optional(string()),
		avbId: optional(string()),
		googleId: string(),
	})
);

export type HistoryGMBLocationDto = Infer<typeof HistoryGMBLocationDto>;
